import { APIClient } from '../../helpers/api_helper';

const api = new APIClient();

export class BlogCategoryService {
  async getAllCategories(params?: any) {
    return api.get('/api/v1/blogs/admin/category/list', params);
  }
  async addCategory(data: any) {
    return api.create('/api/v1/blogs/admin/category/add', data);
  }
  async editCategory(id: string, data: any) {
    return api.create(`/api/v1/blogs/admin/category/edit/${id}`, data);
  }
  async deleteCategory(id: string) {
    return api.create(`/api/v1/blogs/admin/category/delete/${id}`, {});
  }
}

export const blogCategoryService = new BlogCategoryService(); 